import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { AddPropertyModalComponent } from './components/add-property-modal/add-property-modal.component';
// import { AppointmentDeclinePopupComponent } from './components/appointment-decline-popup/appointment-decline-popup.component';
// import { AppointmentFeedbackPopupComponent } from './components/appointment-feedback-popup/appointment-feedback-popup.component';
// import { AppointmentPropertyMiniPopup } from './components/appointment-property-minipopup/appointment-property-minipopup.component';
import { ChatDurationPipe } from './pipes/chat-duration.pipe';
// import { ChatNotificationComponent } from './components/chat-notification/chat-notification.component';
// import { ComingSoonComponent } from './components/coming-soon/coming-soon.component';
import { CommonModule } from '@angular/common';
// import { DocumentsTablePopupComponent } from './components/documents-table-popup/documents-table-popup.component';
// import { LocationOutOfReachPopupComponent } from './components/location-out-of-reach-popup/location-out-of-reach-popup.component';
// import { DocumentsTablePrivatePopupComponent } from './components/documents-table-private-popup/documents-table-private-popup.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { EditDocumentsPopupComponent } from './components/edit-documents-popup/edit-documents-popup.component';
import { FilterListPipe } from './pipes/filterlist.pipe';
// import { FooterComponent } from './components/app-footer/app-footer.component';
// import { FullCalendarSharedComponent } from './components/full-calendar/full-calendar.component';
// import { LeadManagementPopupComponent } from './components/lead-management-popup/lead-management-popup.component';
// import { ListingPaymentComponent } from './components/listing-payment/listing-payment.component';
// import { LocationMapComponent } from './components/location-map/location-map.component';
import { MarkedDirective } from './directives/marked.directive';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './directives/numbersonly.directive';
import { HandleActiveDirective } from './directives/handle-active.directive';
import { PhoneMask } from './directives/phonemasks.directive';

// import { PdfLogsComponent } from './components/pdf-logs-popup/pdf-logs-popup.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
// import { PreferencesRestrictionPopupComponent } from './components/preferences-restriction-popup/preferences-restriction-popup.component';
// import { PropertyAppointmentPopupComponent } from './components/property-appointment-popup/property-appointment-popup.component';
// import { PropertyCompleteProgressComponent } from './components/property-complete-progress/property-complete-progress.component';
// import { PropertyDocumentDisclosureComponent } from './components/property-document-disclosure/property-document-disclosure.component';
import { PropertyListItemComponent } from './components/property-list-item/property-list-item.component';
// import { PropertyListItemDetailComponent } from './components/property-list-item-detail/property-list-item-detail.component';
// import { PropertyListItemEditModalComponent } from './components/property-list-item-edit-modal/property-list-item-edit-modal.component';
// import { PropertyPreferencesComponent } from './components/property-preferences/property-preferences.component';
// import { PropertyScheduleShowingComponent } from './components/property-schedule-showing/property-schedule-showing.component';
// import { PropertySearchDrawerComponent } from './components/property-search-drawer/property-search-drawer.component';
// import { PropertyShareComponent } from './components/property-share-listing/property-share.component';
// import { PropertyShareViaEmailComponent } from './components/property-share-via-email/property-share-via-email.component';
// import { PropertyStatusChangePopupComponent } from './components/property-status-change-popup/property-status-change-popup.component';
// import { PropertyUploadCustomFormPopupComponent } from './components/property-upload-custom-form-popup/property-upload-custom-form-popup.component';
import { RouterModule } from '@angular/router';
// import { SellerContactsComponent } from './components/seller-contacts/seller-contacts.component';
// import { SendSupportEmailComponent } from './components/send-support-email/send-support-email.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';
// import { AppSlickCarouselComponent } from '../public/shared-public/components/slick-carousel/slick-carousel.component';
import { ItemHelpComponent } from '../public/shared-public/components/item-help/item-help.component';
import { SelectModalComponent } from './components/select-modal/select-modal.component';
// import { HelpListComponent } from '../public/shared-public/components/help-list/help-list.component';
// import { SignaturewizardAgentComponent } from './components/signaturewizard-agent/signaturewizard-agent.component';
// import { SignaturewizardComponent } from './components/signaturewizard/signaturewizard.component';
// import { AfterSignupSurvey } from './components/after-signup-survey/after-signup-survey.component';
// import { AfterSignupPhone } from './components/after-signup-add-phone/after-signup-add-phone.component';
// import { SingleChatPopupComponent } from './components/single-chat-popup/single-chat-popup.component';
// import { MultipleChatPopupComponent } from './components/multiple-chat-popup/multiple-chat-popup.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

// import { ViewerwizardComponent } from './components/viewerwizard/viewerwizard.component';
// import { ViewerwizardReadOnlyComponent } from './components/viewerwizardreadonly/viewerwizardreadonly.component';
// import { EditOfferComponent } from './components/offer-edit/offer-edit.component';
// import { HomeValuationEditModalComponent } from './components/house-valuation-edit-modal/house-valuation-edit-modal.component';
// import { OfferBuyerComponent } from './components/offer-buyer/offer-buyer.component';
// import { OfferListingComponent } from './components/offer-listing/offer-listing.component';
// import { OfferDetailViewComponent } from './components/offer-detail-view/offer-detail-view.component';
// import { NewAgentSupportStartingTimeComponent } from './components/new-agent-support-starting-time/new-agent-support-starting-time.component';
// import { OfferSignaturewizardComponent } from './components/offer-signaturewizard/offer-signaturewizard.component';
// import { OfferViewerwizardComponent } from './components/offer-viewerwizard/offer-viewerwizard.component';
// import { ViewerwizardSellerComponent } from './components/viewerwizard-seller/viewerwizard-seller.component';
// import { SignaturewizardSellerComponent } from './components/signaturewizard-seller/signaturewizard-seller.component';
// import { OfferDeclinePopupComponent } from './components/offer-decline-popup/offer-decline-popup.component';
// import { PropertyListItemDwellingTypesComponent } from './components/property-list-item-dwelling-types/property-list-item-dwelling-types.component';
// import { OfferLogsComponent } from './components/offer-logs/offer-logs.component';
// import { OfferShareViaEmailComponent } from './components/offer-share-via-email/offer-share-via-email.component';
import { CommonDirectivesModule } from '../common-directives/common-directives.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { SHARED_ZORRO_MODULES } from './shared-zorro.module';
import { FullCalendarModule } from '@fullcalendar/angular';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { MaskedInputDirective } from './directives/masked-input.directive';


import { PerfectScrollbarShimModule } from './perfect-scrollbar-shim/perfect-scrollbar-shim.module';
import { AppSlickCarouselComponent } from './components/slick-carousel/slick-carousel.component';
// import { CroppieModule } from 'angular-croppie-module';
import { DeferLoadDirective } from '../sharedmodule/directives/defer-load.directive';
import { CollapsePanelTitleMultilineDirective } from './directives/collapse-panel-title-multiline.directive';
import { ReversePipe } from './pipes/reverse.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { VirtualKeyboardFooterDirective } from './components/user-buyer-offer-form/virtual-keyboard-onfocusblur.directive';
import { TitleCasePipe } from './pipes/titlecase.pipe';
import { FavouritePropertyListComponent } from './components/favourite-property-list/favourite-property-list.component';
// import { LocationMapComponent } from './components/location-map/location-map.component';
// import { ImageLazyLoadDirective } from '../sharedmodule/directives/image-lazy-load.directive';
// import { AgentSupportComponent } from './components/agent-support/agent-support.component';

@NgModule({
  declarations: [
    // AddPropertyModalComponent,
    // PdfLogsComponent,
    // ViewerwizardReadOnlyComponent,
    // PropertyListItemDetailComponent,
    // PreferencesRestrictionPopupComponent,
    // SignaturewizardAgentComponent,
    // PropertyListItemEditModalComponent,
    // ImageLazyLoadDirective,
    // HelpListComponent,
    // SellerContactsComponent,
    // PropertyPreferencesComponent,
    // PropertyShareComponent,
    // AppointmentPropertyMiniPopup,
    // SendSupportEmailComponent,
    // DocumentsTablePrivatePopupComponent,
    // EditDocumentsPopupComponent,
    // SignaturewizardComponent,
    // LeadManagementPopupComponent,
    // PropertyCompleteProgressComponent,
    // PropertyDocumentDisclosureComponent,
    // PropertyAppointmentPopupComponent,
    // SingleChatPopupComponent,
    // MultipleChatPopupComponent,
    // AppointmentDeclinePopupComponent,
    // PropertySearchDrawerComponent,
    // FullCalendarSharedComponent,
    // ComingSoonComponent,
    // ListingPaymentComponent,
    // LocationMapComponent,
    // PropertyStatusChangePopupComponent,
    // PropertyUploadCustomFormPopupComponent,
    // AfterSignupSurvey,
    // AfterSignupPhone,
    // AppointmentFeedbackPopupComponent,
    // ChatNotificationComponent,
    // ViewerwizardComponent,
    // PropertyScheduleShowingComponent,
    // DocumentsTablePopupComponent,
    // LocationOutOfReachPopupComponent,
    // FooterComponent,
    // PropertyShareViaEmailComponent,
    // EditOfferComponent,
    // HomeValuationEditModalComponent,
    // OfferBuyerComponent,
    // OfferListingComponent,
    // OfferDetailViewComponent,
    // AgentSupportComponent,
    // NewAgentSupportStartingTimeComponent,
    // OfferSignaturewizardComponent,
    // OfferViewerwizardComponent,
    // ViewerwizardSellerComponent,
    // SignaturewizardSellerComponent,
    // OfferDeclinePopupComponent,
    // PropertyListItemDwellingTypesComponent,
    // OfferLogsComponent,
    // OfferShareViaEmailComponent,
  ],
  imports: [
    CommonModule,
    PropertyListItemComponent,
    FavouritePropertyListComponent,
    ModalContainerComponent,
    ItemHelpComponent,
    SelectModalComponent,
    AppSlickCarouselComponent,
    VirtualKeyboardFooterDirective,
    MarkedDirective,
    DeferLoadDirective,
    CollapsePanelTitleMultilineDirective,
    NumberOnlyDirective,
    HandleActiveDirective,
    PhoneMask,
    ChatDurationPipe,
    FilterListPipe,
    ReversePipe,
    SafePipe,
    PhoneNumberPipe,
    TitleCasePipe,
    MaskedInputDirective,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PickerModule,
    DragDropModule,
    ShareButtonsModule,
    ShareIconsModule,
    FullCalendarModule,
    PdfViewerModule,
    MatChipsModule,
    SignaturePadComponent,
    SlickCarouselModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    CurrencyMaskModule,
    CommonDirectivesModule,
    NgxDropzoneModule,
    PerfectScrollbarShimModule,
    ...SHARED_ZORRO_MODULES,
    // AppSlickCarouselComponent,
    // CroppieModule,
  ],
  exports: [
    // AddPropertyModalComponent,
    // PropertyListItemDetailComponent,
    VirtualKeyboardFooterDirective,
    PropertyListItemComponent,
    FavouritePropertyListComponent,
    ModalContainerComponent,
    AppSlickCarouselComponent,
    ItemHelpComponent,
    SelectModalComponent,
    // HelpListComponent,
    // ViewerwizardReadOnlyComponent,
    // PropertyListItemEditModalComponent,
    // PropertySearchDrawerComponent,
    // ComingSoonComponent,
    // PdfLogsComponent,
    // DocumentsTablePrivatePopupComponent,
    // SendSupportEmailComponent,
    // LeadManagementPopupComponent,
    // PreferencesRestrictionPopupComponent,
    // FullCalendarSharedComponent,
    // SellerContactsComponent,
    // SingleChatPopupComponent,
    // MultipleChatPopupComponent,
    // SignaturewizardAgentComponent,
    // PropertyPreferencesComponent,
    // PropertyShareComponent,
    // LocationMapComponent,
    // ListingPaymentComponent,
    // PropertyStatusChangePopupComponent,
    // PropertyUploadCustomFormPopupComponent,
    // AppointmentFeedbackPopupComponent,
    // EditDocumentsPopupComponent,
    // AppointmentPropertyMiniPopup,
    // AfterSignupSurvey,
    // AfterSignupPhone,
    // AppointmentDeclinePopupComponent,
    // PropertyCompleteProgressComponent,
    // PropertyAppointmentPopupComponent,
    // DocumentsTablePopupComponent,
    // LocationOutOfReachPopupComponent,
    // ChatNotificationComponent,
    // ViewerwizardComponent,
    // SignaturewizardComponent,
    // PropertyScheduleShowingComponent,
    // FooterComponent,
    // ViewerwizardSellerComponent,
    // PropertyDocumentDisclosureComponent,
    // PropertyShareViaEmailComponent,
    NumberOnlyDirective,
    HandleActiveDirective,
    PhoneMask,
    MarkedDirective,
    DeferLoadDirective,
    CollapsePanelTitleMultilineDirective,
    // ImageLazyLoadDirective,
    CurrencyMaskModule,
    ChatDurationPipe,
    FilterListPipe,
    ReversePipe,
    SafePipe,
    PhoneNumberPipe,
    TitleCasePipe,
    // EditOfferComponent,
    // HomeValuationEditModalComponent,
    // AgentSupportComponent,
    SlickCarouselModule,
    // PropertyListItemDwellingTypesComponent,
    // OfferDetailViewComponent,
    // OfferLogsComponent,
    // OfferShareViaEmailComponent,
    SignaturePadComponent,
    FullCalendarModule,
    PerfectScrollbarShimModule,
    ...SHARED_ZORRO_MODULES,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    NgxDropzoneModule,
    DragDropModule,
    PdfViewerModule,
    MaskedInputDirective,
    PickerModule,
    FormsModule,
    ReactiveFormsModule,
    // CroppieModule,
    ShareButtonsModule,
    ShareIconsModule,
    RouterModule,
  ],
  providers: [],
  bootstrap: [],
})
export class SharedModule {}
